import { useCallback, useContext, useMemo } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { useCustomFetch } from '@/hooks/useCustomFetch';
import { baseUrl } from '@/utils/constants';

export default function useCache() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const adminCacheUrl = useMemo(() => {
    return `${baseUrl}admin/cache`;
  }, []);

  const clearServerCache = useCallback(async (): Promise<void> => {
    if (authResult?.accessToken == null) {
      throw new Error('Missing access token. Please refresh your login and try again.');
    }

    await customFetch<null>(`${adminCacheUrl}/clear`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });
  }, [adminCacheUrl, authResult?.accessToken, customFetch]);

  const clearClientCache = useCallback(async (): Promise<void> => {
    sessionStorage.clear();

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }
  }, []);

  const bustCache = useCallback(async (): Promise<void> => {
    await clearServerCache();
    await clearClientCache();
  }, [clearClientCache, clearServerCache]);

  return { bustCache, clearServerCache, clearClientCache };
}
